var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 1.34315 1.34315 0 3 0H19C20.6569 0 22 1.34315 22 3V13C22 14.6569 20.6569 16 19 16H3C1.34315 16 0 14.6569 0 13V3ZM3 2C2.44772 2 2 2.44772 2 3V4.03001C2.08078 4.01033 2.16438 4 2.25 4H19.75C19.8356 4 19.9192 4.01033 20 4.03001V3C20 2.44772 19.5523 2 19 2H3ZM2 13V6.96999C2.08078 6.98967 2.16438 7 2.25 7H19.75C19.8356 7 19.9192 6.98967 20 6.96999V13C20 13.5523 19.5523 14 19 14H3C2.44772 14 2 13.5523 2 13ZM4.33333 10C4.14924 10 4 10.4477 4 11C4 11.5523 4.14924 12 4.33333 12H7.66667C7.85076 12 8 11.5523 8 11C8 10.4477 7.85076 10 7.66667 10H4.33333Z",
    fill: "#FDF4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.733ef96ae13757b1973c61080521f847.svg";
export { ForwardRef as ReactComponent };